import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OfferFitDimensionDetails = lazy(() =>
  import(
    "@scenes/OfferFit/components/OfferFitUseCaseDetails/components/OfferFitUseCaseConfiguration/components/OfferFitDimensionDetails"
  ).then((module) => ({
    default: module.OfferFitDimensionDetails,
  }))
);

export const offerfitDimensionDetailsNRO: NavigationRoutingObject = {
  Component: OfferFitDimensionDetails,
  componentFeatureFlippers: ["offerfit_dashboard", "offerfit_use_case_configuration"],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-dimension-details-nro-heading", "BrazeAI Decisioning Studio™ Dimension Details"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-dimension-details-nro-description", "View actions for a BrazeAI Decisioning Studio™ dimension"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("offerfit_dashboard")) {
      return false;
    }

    const userHasViewDecisioningStudioAgentsPermission = hasPermission("appGroup", {
      permission: "viewDecisioningStudioAgents",
    });

    return isImpersonating || userHasViewDecisioningStudioAgentsPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
